/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum GoodsLocationType {
  A = 0,
  B = 1,
  C = 2,
}
